import React, { useEffect, useRef } from "react";
import PropTypes from "prop-types";
import ProfileLabeledInput from "./profile-labeled-input.js";

export default function ProfileLoginForm({
  texts,
  username,
  onChangeUsername,
  password,
  onChangePassword,
  errors,
  onSubmit,
  onGotoCreerCompte,
  onShowForgotPassword,
}) {
  const usernameInputRef = useRef(null);

  useEffect(() => {
    if (usernameInputRef.current != null)
      usernameInputRef.current.focus();
  }, []);

  const onLoginFieldKeyDown = e => {
    if (e.key === "Enter") {
      e.preventDefault();
      onSubmit();
    }
  };

  return (
    <form
      id="profile-page"
      onSubmit={e => {
        e.preventDefault();
        onSubmit();
      }}
    >
      <div className="display-inline-block">
        <ProfileLabeledInput ref={usernameInputRef} label={texts.username} value={username} onChange={e => onChangeUsername(e.target.value)} errors={errors.username} />
        <ProfileLabeledInput type="password" label={texts.password} value={password} onChange={e => onChangePassword(e.target.value)} errors={errors.password} />
        <div className="profile-div">
          <button type="submit" className="profile-div btn-login clickable">
            <span className="profile-span">{texts.login}</span>
          </button>
        </div>
        <div className="profile-div" style={{ textAlign: "center" }}>
          <span className="clickable primary-color message profile-span" onClick={e => onGotoCreerCompte()}>
            {texts.text0}
          </span>
        </div>
        <div className="profile-div" style={{ textAlign: "center" }}>
          <span className="clickable primary-color message profile-span" onClick={e => onShowForgotPassword()}>
            {texts.text1}
          </span>
        </div>
      </div>
    </form>
  );
}

ProfileLoginForm.propTypes = {
  texts: PropTypes.object.isRequired,
  username: PropTypes.string.isRequired,
  onChangeUsername: PropTypes.func.isRequired,
  password: PropTypes.string.isRequired,
  onChangePassword: PropTypes.func.isRequired,
  errors: PropTypes.object.isRequired,
  onSubmit: PropTypes.func.isRequired,
  onGotoCreerCompte: PropTypes.func.isRequired,
  onShowForgotPassword: PropTypes.func.isRequired,
};
